import { Link } from './link';
import { Observable } from 'rxjs/Observable';

export abstract class AbstractResource<T> {
  public item: T;
  public links: Array<Link>;
  public resolved: Map<string, any> = new Map<string, any>();

  constructor(item: T, links: Array<Link>) {
    this.item = item;
    this.links = links;
  }

  public addResource(name : string, item: any): void {
    this.resolved.set(name, item);
  }

}
